import { useMutation } from "@tanstack/react-query";
import { createFolder } from "../lib/api/folders";
import { queryClient } from "../lib/queryClient";
import { qk } from "../lib/queryKeys";
import { useToast } from "../providers/ToastProvider";
import type { FolderDTO } from "../lib/api/types";

export function useCreateFolder(parentId: string | null) {
  const { push } = useToast();
  return useMutation<FolderDTO, unknown, { name: string }>({
    mutationFn: ({ name }) => createFolder({ name, parentId }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: qk.contents(parentId) });
      push({ kind: "success", message: "Folder created" });
    },
  });
}
